// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"support_sidebarWrapper__-z6wD","mainWrapper":"support_mainWrapper__mJBte","contactsIcon":"support_contactsIcon__iB1aw"};